import angular from 'angular';
import uiRouter from 'angular-ui-router';
import loginSuperAdmin from './loginSuperAdmin.component';

const loginSuperAdminModule = angular.module('tinaba.components.loginSuperAdmin', [
  uiRouter
])

// .config(($stateProvider) => {
//   'ngInject';

  // $stateProvider.state('loginSuperAdmin', {
  //   url: '/loginSuperAdmin'
  // });
// })

.component('loginSuperAdmin', loginSuperAdmin);

export default loginSuperAdminModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/loginSuperAdmin/loginSuperAdmin.js
 **/